const fbPageStatus = {
    CONNECTED: "CONNECTED",
    NEEDS_RECONNECT: "NEEDS_RECONNECT",
    UNKNOWN: "UNKNOWN",
}

export default fbPageStatus;
